import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {fromEvent as observableFromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {fuseAnimations} from '../../../../core/animations';
import {EditSpaceModal} from './edit-modal/edit-space.modal';
import {MatDialog} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {TranslateService} from '@ngx-translate/core';
import {SpaceService} from '../../../../core/services/space.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'spaces',
    templateUrl: './spaces.component.html',
    styleUrls: ['./spaces.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class SpacesComponent implements OnInit{
  pageSize = 20;
  pageIndex = 0;
  search = '';
  totalCount = 0;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  public filterData: any = {};
  spaces = [];
  constructor(public spaceService: SpaceService, public dialog: MatDialog, public toastr: ToastrService,
              public translate: TranslateService) {}

  ngOnInit() {
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this.search = this.filter.nativeElement.value;
          // this.paginator.firstPage();
          this.getSpaces();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this.search){
          this.search = '';
          // this.paginator.firstPage();
          this.getSpaces();
        }
      });
    this.getSpaces();
  }

  getSpaces() {
    this.spaceService.getSpaceBoards(this.pageIndex + 1, this.pageSize, this.search).subscribe((res: any) => {
      if (res && res.spaces) {
        this.spaces = res.spaces;
        this.totalCount = res.pagination.total;
      }
    });
  }

  changePageEmitter(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.getSpaces();
  }

  editSpace(id, name, platformId) {
    const dialogRef = this.dialog.open(EditSpaceModal , {
      width: '400px',
      data: {data: name, platformId: platformId}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          id: id,
          name: result.name,
          platformId: result.platformId
        };
        this.spaceService.addSpace(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('space_edited');
            this.toastr.success(msg, title);
            this.getSpaces();
          }
        });
      }
    });
  }

  deleteSpace (id) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'delete_space'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spaceService.deleteSpace(id).subscribe((res: any) => {
          if (res && !res.error) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('space_deleted');
            this.toastr.success(msg, title);
            this.getSpaces();
          }
        });
      }
    });
  }

  editSpaceBoard(board, spaceId) {
    const dialogRef = this.dialog.open(EditSpaceModal , {
      width: '400px',
      data: {data: board.name, type: 'sub'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          id: board.id,
          name: result.name,
          spaceId
        };
        this.spaceService.addSpaceBoard(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('board_edited');
            this.toastr.success(msg, title);
            let index = this.spaces.findIndex(el => +el.id === +spaceId);
            if (index !== -1) {
              let subIndex = this.spaces[index].spaceBoard.findIndex(el => +el.id === +board.id);
              if (subIndex !== -1) {
                this.spaces[index].spaceBoard[subIndex].name = result.name;
              }
            }
          }
        });
      }
    });
  }

  deleteSpaceBoard (id, spaceId) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'delete_board'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spaceService.deleteSpaceBoard(id).subscribe((res: any) => {
          if (res && !res.error) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('board_removed');
            this.toastr.success(msg, title);
            let index = this.spaces.findIndex(el => +el.id === +spaceId);
            if (index !== -1) {
              let subIndex = this.spaces[index].spaceBoard.findIndex(el => +el.id === +id);
              if (subIndex !== -1) {
                this.spaces[index].spaceBoard.splice(subIndex, 1);
              }
            }
          }
        });
      }
    });
  }

  addSpaceBoard(spaceId) {
    const dialogRef = this.dialog.open(EditSpaceModal , {
      width: '400px',
      data: {type: 'create_sub'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          name: result.name,
          spaceId
        };
        this.spaceService.addSpaceBoard(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('board_created');
            this.toastr.success(msg , title);
            let index = this.spaces.findIndex(el => +el.id === +spaceId);
            if (index !== -1) {
              this.spaces[index].spaceBoard.push(res);
            }
          }
        });
      }
    });
  }

  drop(event: any, index) {
    moveItemInArray(this.spaces[index].spaceBoard, event.previousIndex, event.currentIndex);
    console.log(this.spaces[index].spaceBoard);
    for (let i = 0; i < this.spaces[index].spaceBoard.length; i++) {
      let data = {
        name: this.spaces[index].spaceBoard[i].name,
        spaceId: this.spaces[index].spaceBoard[i].spaceId,
        id: this.spaces[index].spaceBoard[i].id,
        sortNumber: (i + 1)
      };
      this.spaceService.addSpaceBoard(data).subscribe();
    }
  }

  dropSpaces(event: any) {
    moveItemInArray(this.spaces, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.spaces.length; i++) {
      let data = {
        name: this.spaces[i].name,
        platformId: this.spaces[i].platformId,
        id: this.spaces[i].id,
        sortNumber: (i + 1)
      };
      this.spaceService.addSpace(data).subscribe();
    }
  }
}
